// @ts-nocheck
import InputLabelField from '@/components/form-control/InputLabelField'
import { useAuthContext } from '@/features/auth/context'
import { useConfigUI } from '@/features/config/context'
import { yupResolver } from '@hookform/resolvers/yup'
import { LoadingButton } from '@mui/lab'
import { Button, Container, Stack, Typography } from '@mui/material'
import { useEffect, useRef } from 'react'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { useUpdateSite } from '../../../hooks/sitesandlocations'

interface SiteViewProps {
  id?: string
  name?: string
}

const schema = yup
  .object({
    siteName: yup.string().required('Site Name is required'),
  })
  .required()

const SiteView = ({ id, name }: SiteViewProps) => {
  const { closeSidebar } = useConfigUI()
  const { interfaceId } = useAuthContext()
  const inputRefSiteName = useRef<HTMLInputElement>(null)
  const { mutate: updateSite, isLoading: loadingUpdateSite } = useUpdateSite()

  useEffect(() => {
    if (inputRefSiteName.current) {
      inputRefSiteName.current.focus()
    }
  }, [])
  const form = useForm({
    defaultValues: {
      siteName: name,
    },
    resolver: yupResolver(schema),
  })

  const handleSave = (data: any) => {
    updateSite({
      id: Number(id),
      name: data.siteName,
      interfaceId: interfaceId,
    })
  }

  return (
    <Container sx={{ maxWidth: '450px' }}>
      <form onSubmit={form.handleSubmit(handleSave)}>
        <Stack sx={{ padding: '34px 18px' }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ width: '377px' }}
          >
            <Typography
              color="text.main"
              sx={{
                fontWeight: '500',
                fontSize: '14px',
                color: '#000000',
              }}
            >
              Edit Site
            </Typography>
            <Stack direction="row">
              <Button
                size="small"
                color="secondary"
                sx={{ marginRight: '7px', width: '85px' }}
                onClick={() => closeSidebar()}
              >
                Cancel
              </Button>
              <LoadingButton
                loading={loadingUpdateSite}
                color="primary"
                variant="contained"
                sx={{ minWidth: '72px', padding: 0 }}
                type="submit"
              >
                Save
              </LoadingButton>
            </Stack>
          </Stack>

          <InputLabelField
            name="siteName"
            form={form}
            label="Site"
            placeholder="Site Name"
            style={{
              borderRadius: '4px',
              width: { xs: '377px' },
              marginTop: '22px',
            }}
            inputRef={inputRefSiteName}
            required
          />
        </Stack>
      </form>
    </Container>
  )
}

export default SiteView
